export const DEVELOPMENT_ENV = "development";
export const PRODUCTION_ENV = "production";

// mobile responsive consts
export const DESKTOP_SCREEN = 960;
export const MOBILE_SCREEN = 320;
export const WIDGET_SCREEN = 319;

// personalization data actions
export const SAVE_APP_DATA = "SAVE_APP_DATA";
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";
export const RESET_APP_ERROR = "RESET_APP_ERROR";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_CHILDREN_YEARS_LIST = "SET_CHILDREN_YEARS_LIST";
export const CHANGE_YEARS_LIST_VALUES = "CHANGE_YEARS_LIST_VALUES";
export const SET_YEARS_STRING = "SET_YEARS_STRING";

export const UPDATE_STEP_COUNT = "UPDATE_STEP_COUNT";

// COMMON
export const POSITIVE_RESPONSE = "Yes";
export const NEGATIVE_RESPONSE = "No";

export const YES_NO_OPTIONS = [
  { label: POSITIVE_RESPONSE, value: true },
  { label: NEGATIVE_RESPONSE, value: false },
];

export const CHILD_NUMBER_OPTIONS = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10+", value: 10 },
];

export const EMPLOYMENTS_STATUS_OPTIONS = [
  { label: "Unemployed", value: "UNEMPLOYED" },
  { label: "Employed", value: "EMPLOYED" },
  { label: "Self Employed", value: "SELF_EMPLOYED" },
  {
    label: "Hybrid - Self Employed and Employed",
    value: "HYBRID_SELF_EMPLOYED_AND_EMPLOYED",
  },
];

export const RELATIONSHIP_STATUS_OPTIONS = [
  { label: "Single", value: "SINGLE" },
  { label: "Cohabitate", value: "COHABITATE" },
  { label: "Married", value: "MARRIED" },
  { label: "Registered / Legal Partnership", value: "REGISTERED" },
  { label: "Divorced", value: "DIVORCED" },
  { label: "Widowed", value: "WIDOWED" },
];

export const GENDER_OPTIONS = [
  { label: "Male", value: "MALE" },
  { label: "Female", value: "FEMALE" },
  { label: "Other", value: "OTHER" },
];

export const TIME_AFTER_BIRTH_OPTIONS = [
  { label: "0-2 weeks", value: "0_2_WEEKS" },
  { label: "2-4 weeks", value: "2_4_WEEKS" },
  { label: "4-12 weeks", value: "4_12_WEEKS" },
  { label: "12-26 weeks", value: "12_26_WEEKS" },
  { label: "26+ weeks", value: "26_MORE_WEEKS" },
];

export const CHILD_LEGAL_PARENT_ONE_OPTIONS = [
  { label: "Parent 1 (as provided above)", value: "PARENT_1" },
  { label: "Other", value: "OTHER" },
  { label: "None", value: "NONE" },
];

export const CHILD_LEGAL_PARENT_TWO_OPTIONS = [
  { label: "Parent 2 (as provided above)", value: "PARENT_2" },
  { label: "Other", value: "OTHER" },
  { label: "None", value: "NONE" },
];
